import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=4bbea1ac&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=4bbea1ac&prod&scoped=true&lang=css&"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=4bbea1ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbea1ac",
  null
  
)

/* custom blocks */
import block0 from "./SideBar.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports